import { IDropdownProps } from 'legacy/lut/library/dropdown'
import { ReactNode } from 'react'

import { Checkbox } from 'core-components/library/checkbox'
import { ICheckboxProps } from 'core-components/library/checkbox/Checkbox'
import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import { OnboardingDropdown } from 'onboarding/components/ui/theme'

import styles from '../PartnerShipNA.module.scss'

import { Choice } from './constants'
import { IPartnerShipNA, IPartnerShipNaCrud } from './types'

interface IProps {
  item: IPartnerShipNA
  writeAudience: IObjectAny
  onChange: (field: string, isNumber?: boolean) => (value: string) => void
  cruds: Pick<IPartnerShipNaCrud, 'IsDistributor'>
  disabled?: boolean
}

interface IQuestionProps extends IProps {
  title: string
  field: string
  options: { [Choice.Yes]: string; [Choice.No]: string }
  detail?: ReactNode
}

export const CompanySales = (props: IProps) => {
  const { item, writeAudience, onChange, cruds, disabled } = props

  return (
    <div className={styles.companySalesContainer}>
      <div className={styles.companySalesQuestions}>
        <Question
          title={
            'You are applying for a T2 Reseller Relationship, you can only sell to End Users and not to another Resellers. Do you agree?'
          }
          field={'AgreeSellToEndUsers'}
          options={Choice}
          {...props}
        />
        <Question
          title={
            'Our HP Partner Agreement does not allow international transactions; you can only sell HP Products within your territory. Do you agree?'
          }
          field={'AgreeSellProductsInTerritory'}
          options={Choice}
          {...props}
        />
      </div>

      <div className={styles.companySalesDistributorContainer}>
        <div className={styles.companySalesRow}>
          <VisualAudienceExtended<IDropdownProps>
            write={writeAudience}
            component={OnboardingDropdown}
            classes={{
              controlClasses: {
                root: styles.companySalesAnswerWidth,
              },
            }}
            label={'Are you a distributor?'}
            caption={'label'}
            source={cruds.IsDistributor}
            onChange={onChange('AreYouDistri')}
            value={item.AreYouDistri || ''}
            disabled={disabled}
          />
        </div>
        <Question
          title={'All sales must be conducted through your own direct website (URL). Do you agree?'}
          field={'AgreeSellThroughOwnURL'}
          options={Choice}
          {...props}
        />
      </div>
    </div>
  )
}

const Question = ({
  item,
  writeAudience,
  disabled,
  onChange,
  title,
  field,
  options,
  detail,
}: IQuestionProps) => {
  const choice = item[field]
  const optionYes = options[Choice.Yes]
  const optionNo = options[Choice.No]

  return (
    <div className={styles.companySalesRow}>
      <div className={styles.companySalesQuestion}>{title}</div>

      <div className={styles.companySalesAnswerBlock}>
        <div className={styles.companySalesAnswer}>
          <VisualAudienceExtended<ICheckboxProps>
            component={Checkbox}
            write={writeAudience}
            label={'Yes'}
            checked={choice === optionYes}
            disabled={disabled}
            onChange={() => onChange(field)(optionYes)}
            inline
          />
          <VisualAudienceExtended<ICheckboxProps>
            component={Checkbox}
            write={writeAudience}
            label={'No'}
            checked={choice === optionNo}
            className={styles.companySalesAnswerSpacing}
            disabled={disabled}
            onChange={() => onChange(field)(optionNo)}
            inline
          />
        </div>
        {detail ? <div className={styles.companySalesQuestionDetailWrapper}>{detail}</div> : null}
      </div>
    </div>
  )
}
